var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindSpeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 14,
    viewBox: "6 14 34 23",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.Round_x0020_Corners_x0020_2_x0020_pt{fill:#FFFFFF;stroke:#231F20;stroke-miterlimit:10;}\n\t.Live_x0020_Reflect_x0020_X{fill:none;}\n\t.Bevel_x0020_Soft{fill:url(#SVGID_1_);}\n\t.Dusk{fill:#FFFFFF;}\n\t.Foliage_GS{fill:#FFDD00;}\n\t.Pompadour_GS{fill-rule:evenodd;clip-rule:evenodd;fill:#44ADE2;}\n\t.st0{fill:none;stroke:#303030;stroke-width:0.7;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#303030;stroke-width:0.7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#303030;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#303030;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#303030;}\n\t.st5{fill:none;stroke:#303030;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#303030;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#303030;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#303030;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#303030;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#303030;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#303030;stroke-width:0.75;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_",
    x1: -174.07109,
    x2: -173.364,
    y1: -57.9689,
    y2: -57.26179
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEDFE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17833,
    style: {
      stopColor: "#DADBDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36114,
    style: {
      stopColor: "#CECFD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54604,
    style: {
      stopColor: "#B9BCBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7324,
    style: {
      stopColor: "#9CA0A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91815,
    style: {
      stopColor: "#787D7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#656B6C"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Padding__x26__Artboard"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 24.57397,
    cy: 18.58981,
    rx: 2.48028,
    ry: 0.5402
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "22.09369,18.58978 21.33234,26.15334 22.21651,27.18476 27.17695,27.18476 28.1359,26.11423        27.05424,18.58978      "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 21.35183,
    x2: 27.96824,
    y1: 25.96091,
    y2: 25.99575
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.1578,19.31067l5.23578-0.72089c0,0,1.26124-0.31959,1.282-1.20872"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.38085,20.86205c0.19473-0.02787,5.1781-0.66892,5.1781-0.66892s1.21996-0.08257,1.26136,1.22018"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.83911,20.28051c0.49393,2.39656,2.56124,4.19851,5.03097,4.19851       c2.84473,0,5.14989-2.38739,5.14989-5.32374c0-2.93612-2.30516-5.31436-5.14989-5.31436       c-2.68922,0-4.90287,2.13121-5.12236,4.83878"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 21.82293,
    x2: 16.81949,
    y1: 19.79576,
    y2: 20.50918
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 21.63085,
    x2: 16.78291,
    y1: 21.71664,
    y2: 22.10999
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.78291,22.10999c-0.42993,2.60688-2.66181,4.58269-5.36032,4.58269       c-3.00024,0-5.44256-2.46972-5.44256-5.51573c0-3.05515,2.44232-5.52487,5.44256-5.52487       c2.7899,0,5.07672,2.12213,5.3969,4.85711"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 25.56824,
    cy: 21.17274,
    r: 0.78708
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "22.6805,27.18476 23.62775,28.68382 25.56824,28.68382 26.67719,27.18476     "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 5.47525,
    width: 1.47845,
    x: 23.86502,
    y: 28.68382
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.67226,17.12638c0,0,1.4523,2.39106-0.2657,4.44564"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.38074,22.4656c0,0-0.49197,0.23991-0.93464,0.25768"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 11.39973,
    cy: 21.23493,
    r: 4.05691
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M11.39976,22.37203c-1.28807,0-2.36663-0.84863-2.73934-2.01307    c-0.08899,0.27798-0.14977,0.56858-0.14977,0.87603c0,1.59553,1.29346,2.88911,2.88911,2.88911s2.88911-1.29358,2.88911-2.88911    c0-0.30746-0.06089-0.59805-0.14977-0.87603C13.76628,21.5234,12.68784,22.37203,11.39976,22.37203z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindSpeed);
export default __webpack_public_path__ + "static/media/wind_speed.0433c2c4.svg";
export { ForwardRef as ReactComponent };